import { useTranslation } from 'react-i18next'
import { BsArrowUpShort } from 'react-icons/bs'
import { isEmpty } from 'lodash'

const AgentTable = ({
  agent,
  page,
  sort,
  setSort,
  setSelected,
  selected,
  setIsAgentModalOpen,
  setIsAgentNameValid
}) => {
  const { t } = useTranslation()
  const onSelect = item => {
    setSelected(item)
    setIsAgentModalOpen(false)
    setIsAgentNameValid('')
  }
  return (
    <div className='p-3'>
      <div className='overflow-x-auto relative 
 border'>
        <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
          <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
            <tr>
              <th scope='col' className='py-3 px-6'>
                #
              </th>
              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (sort.sortKey === 'name' && sort.sortType === 'asc') {
                    setSort({
                      sortKey: 'name',
                      sortType: 'desc'
                    })
                  } else {
                    setSort({
                      sortKey: 'name',
                      sortType: 'asc'
                    })
                  }
                }}
              >
                <div className='flex'>
                  <span>{t('O_FULL_NAME')} </span>
                  <span>
                    {sort.sortKey === 'name' && sort.sortType === 'asc' && (
                      <BsArrowUpShort className='w-4 h-4' />
                    )}
                    {sort.sortKey === 'name' && sort.sortType === 'desc' && (
                      <BsArrowUpShort className='w-4 h-4 rotate-180' />
                    )}
                  </span>
                </div>
              </th>

              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (sort.sortKey === 'email' && sort.sortType === 'asc') {
                    setSort({
                      sortKey: 'email',
                      sortType: 'desc'
                    })
                  } else {
                    setSort({
                      sortKey: 'email',
                      sortType: 'asc'
                    })
                  }
                }}
              >
                <div className='flex'>
                  <span>{t('O_EMAIL_ADDRESS')} </span>
                  <span>
                    {sort.sortKey === 'email' && sort.sortType === 'asc' && (
                      <BsArrowUpShort className='w-4 h-4' />
                    )}
                    {sort.sortKey === 'email' && sort.sortType === 'desc' && (
                      <BsArrowUpShort className='w-4 h-4 rotate-180' />
                    )}
                  </span>
                </div>
              </th>

              <th scope='col' className='py-3 px-6 text-right'>
                {t('O_COUNTRY_CODE')}
              </th>
              <th scope='col' className='py-3 px-6 text-right'>
                {t('O_MOBILE')}
              </th>
              <th scope='col' className='py-3 px-6 text-right'>
                {t('O_BRN_NUMBER')}
              </th>
              <th scope='col' className='py-3 px-6 text-right'>
                {t('O_ACTION')}
              </th>
            </tr>
          </thead>
          <tbody>
            {agent &&
              agent?.map((item, i) => (
                <tr
                  key={i}
                  className={`${selected?._id === item?._id ?'bg-black':'bg-white'} border-b dark:bg-gray-800 dark:border-gray-700`}
                >
                  <th
                    scope='row'
                    className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                  >
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className='py-2 px-2 border-r'>{item?.name} </td>
                  <td className='py-2 px-2 border-r'>{item?.email}</td>

                  <td className='py-2 px-2 border-r text-right'>
                    {item?.countryCode}{' '}
                  </td>
                  <td className='py-2 px-2 border-r text-right'>
                    {item?.mobile}{' '}
                  </td>
                  <td className='py-2 px-2 border-r'>{item?.brn || 'N/A'}</td>
                  <td
                    className='py-2 px-2 border-r cursor-pointer text-blue-700'
                    onClick={() => onSelect(item)}
                  >
                   {selected?._id === item?._id ? 'Selected' : 'Select'}
                  </td>
                </tr>
              ))}
            {isEmpty(agent) ? (
              <tr className='bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700'>
                <td className='py-4 px-6' colSpan={12}>
                  {t('O_NO_RECORD_FOUND')}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default AgentTable
